import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Badge } from '@/components/ui/badge'
import { faBan } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  enabled?: boolean
  className?: string
}

const FeatureBadge: React.FC<Props> = ({
  children,
  enabled = false,
  className,
}) => {
  const _className = cn(
    'flex-inline items-center gap-2 text-[11px] py-1 px-2.5',
    enabled ? 'text-white' : 'text-dim',
    className,
  )

  return (
    <Badge variant={enabled ? 'success' : 'secondary'} className={_className}>
      {enabled ? (
        <FontAwesomeIcon icon={faCheck} />
      ) : (
        <FontAwesomeIcon icon={faBan} />
      )}
      <span>{children}</span>
    </Badge>
  )
}

export default FeatureBadge
